import { useQuery, useQueryClient } from 'react-query';

import listedKitService from 'resources/listedkit/listedkit.service';

const getListedKitGhost = async (companyId) => {
  const listedKits = await listedKitService.find({ company_id: companyId, is_ghost: true });

  return listedKits;
};

export default function useListedKitGhost(queryOptions) {
  const queryClient = useQueryClient();
  const currentUser = queryClient.getQueryData(['user.currentUser']);

  return useQuery(
    ['listedKits.getGhost', currentUser.company_id],
    () => getListedKitGhost(currentUser.company_id),
    queryOptions,
  );
}
